import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
	ForgetPassword,
	Login,
	ResetPassword,
	OTPPage,
	Mainlayout,
	FormsBuilder,
	Dashboard,
	EmailVerification,
	Print,
	LocalDashboard,
	PageNotFound,
	SMTPSetting,
	UserSetting,
	SurveyForm,
} from "./Pages";
import { LazyLoader } from "./Components";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";

import "./App.css";
import { lazy, useEffect } from "react";

import ProtectRoutes from "./routes/ProtectRoutes";

import { pathname } from "./util/PathName";
import { routeSegmentLabel } from "./util/routeLabel";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import useLogout from "./hooks/useLogout";
import mainComponents from "./routes/mainRoute";
import useDomainChecker from './hooks/useDomainChecker';
import PublicRoutes from "./routes/PublicRoutes";

const SurveyAnalysisPage = lazy(() =>
	import("./Pages/SurveyAnalysis/SurveyAnalysisPage")
);


function App() {
	const location = useLocation();
	const paths = location.pathname.split("/");
	// The browser tab names the page after the last URL segment. On a route
	// that ends in a record id that would be the id itself, so it is read
	// through the same helper the breadcrumb and the page heading use.
	const tabTitle = routeSegmentLabel(paths[paths.length - 1], location);
	const navigate = useNavigate();
	const [admin, setAdmin] = useState(false);
	const [SuperAdmin, setSuperAdmin] = useState(false);
	const user = JSON.parse(localStorage.getItem("User")) || "";
	const adminRole = ["admin", "subscriber", "superadmin", "owner"];
	const [logout] = useLogout();
	const { loading, domain, domainError } = useDomainChecker();

	useEffect(() => {
		const hostName = window.location.hostname.replace("www.", "");
		const domainName = hostName.split(".")[0];
		domainName.toLowerCase() === "login" || domainName.toLowerCase() === "develop" ||
			domainName.toLowerCase() === "localhost"
			? setAdmin(true)
			: setAdmin(false);
		if (user.role === "superadmin") {
			setSuperAdmin(true);
		} else {
			setSuperAdmin(false);
		}
	}, [user?.role]);

	const adminPage = ["report-builder", "formbuilder", "CMS", "useractivity"];

	const superAdminPage = ["CMS"];

	const accesspoint = user?.accesspoint && [...user?.accesspoint?.map((item) =>
		item === "customer" ? "client" : item
		// .split(" ").join("").toLowerCase(),
	),'jobs'];
	console.log("accesspoint",accesspoint)

	const accessState = user?.accessState;

	useEffect(() => {
		const hostName = window.location.hostname;
		localStorage.setItem('apiHost',process.env.REACT_APP_API_LOCAL_URL)
		if (localStorage.getItem("userToken")) {
			if (location.pathname === "/") {
				navigate("/dashboard" + location.search, { replace: true });
			} else {
				navigate(location.pathname + location.search, { replace: true });
			}
		}
	}, []);

	const MainRoutes = (component, index) => {
		// console.log("Form Builder", component);
		if (adminRole.includes(user?.role)) {
			return (
				<Route
					key={index}
					path={component.path}
					element={<LazyLoader>{component.component}</LazyLoader>}
				/>
			);
		} else if (user?.role === "internal" || user?.role === "external") {
			console.log(accesspoint,accessState,"c")
			// console.log("component===>",component)
			// if(component.alternativename==="Recurring Analysis")
				// console.log("Form Builder", component.path,accesspoint.includes(component.path) ,
				// accesspoint.includes(component.path.slice(0, -1)) ,
				// accesspoint.includes(component?.alternativename) ,
				// accesspoint?.some(item => component.path?.split('-')?.join('')?.toLowerCase()?.includes(item?.toLowerCase())),user);
			if (
				accesspoint.includes(component.path) ||
				accesspoint.includes(component.path.slice(0, -1)) ||
				accesspoint.includes(component?.alternativename) ||
				accesspoint?.some(item => component.path?.split('-')?.join('')?.toLowerCase()?.includes(item?.toLowerCase()))
			) {
				if(component?.alternativename && accessState && accessState[component?.alternativename]){
					if(accessState[component?.alternativename].view)
						return (
							<Route
								key={index}
								path={component.path}
								element={<LazyLoader>{component.component}</LazyLoader>}
							/>
						);
				}else
				    return (
						<Route
							key={index}
							path={component.path}
							element={<LazyLoader>{component.component}</LazyLoader>}
						/>
					);
			} else if (
				component.path === "formbuilder" ||
				component.path === "form"
			) {
				const accessPaths = ["Formslist", ""];
				const userAccessPoint = user.accesspoint;
				const isAccessPointPresent = accessPaths.find((value) =>
					userAccessPoint.includes(value),
				);
				if (isAccessPointPresent) {
					return (
						<Route
							key={index}
							path={component.path}
							element={<LazyLoader>{component.component}</LazyLoader>}
						/>
					);
				}
			}
		}
	};

	const accessroutingPage = () => {
		if (admin && !SuperAdmin) {
			return mainComponents.map((component, index) =>
				MainRoutes(component, index),
			);
		} else if (!admin && !SuperAdmin) {
			return mainComponents
				.filter((item) => !adminPage.includes(item.path))
				.map((component, index) => MainRoutes(component, index));
		} else if ((!admin && SuperAdmin) || (admin && SuperAdmin)) {
			return mainComponents
				.filter((item) => !superAdminPage.includes(item.path))
				.map((component, index) => MainRoutes(component, index));
		}
	};

	function cleanup() {
		sessionStorage.removeItem("isRefreshing");
		logout();
	}

	function tabOpened() {
		let tabs = JSON.parse(window.localStorage.getItem("tabs"));

		if (tabs === null) {
			window.localStorage.setItem("tabs", 1);
		} else {
			window.localStorage.setItem("tabs", ++tabs);
		}

		if (
			sessionStorage.getItem("isRefreshing") === null &&
			tabs !== null &&
			tabs <= 1
		) {
			// If the flag is not set, this is a tab close
			// console.log("tabbs")
			window.localStorage.removeItem("tabs");
			cleanup();
			return 0;
		}
		sessionStorage.setItem("isRefreshing", "true");
	}

	function tabClosed() {
		let tabs = JSON.parse(window.localStorage.getItem("tabs"));
		if (tabs >= 1) {
			window.localStorage.setItem("tabs", --tabs);
		}
	}

	window.onload = function () {
		// tabOpened();
	};

	window.onbeforeunload = function () {
		tabClosed();
	};

	return (
		<>
			<Helmet>
				<title>
					{paths[1].length > 0
						? tabTitle.charAt(0).toUpperCase() + tabTitle.slice(1)
						: "Login"}
				</title>
			</Helmet>
			{loading && (
				<div
					className='d-flex justify-content-center align-items-center'
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						height: "100vh",
						width: "100vw",
						zIndex: 9999,
						background: "#fff",
					}}>
					<Spinner animation='border' />
				</div>
			)}
			{!domain ? (
				<Routes>
					<Route
						path='*'
						element={
							<LazyLoader>
								<PageNotFound error={domainError} />
							</LazyLoader>
						}
					/>
				</Routes>
			) : (
				<Routes>
					<Route
						index
						element={ 
							<LazyLoader>
								<Login />
							</LazyLoader>
						}
					/>
					<Route path="/public/*" element={<PublicRoutes />} />
					<Route
						path='templogin'
						element={
							<LazyLoader>
								<Login />
							</LazyLoader>
						}
					/>

					<Route
						path='/'
						element={
							<LazyLoader>
								<Login />
							</LazyLoader>
						}
					/>
					<Route
						path='otp'
						element={
							<LazyLoader>
								<OTPPage />
							</LazyLoader>
						}
					/>
					<Route
						path='forgetpassword'
						element={
							<LazyLoader>
								<ResetPassword />
							</LazyLoader>
						}
					/>
					<Route
						path='user/passwordReset/*'
						element={
							<LazyLoader>
								<ForgetPassword />
							</LazyLoader>
						}
					/>
					<Route
						path='emailverify'
						element={
							<LazyLoader>
								<EmailVerification />
							</LazyLoader>
						}
					/>
					<Route
						path='print'
						element={
							<LazyLoader>
								<Print />
							</LazyLoader>
						}
					/>
					{/* <Route
						path='survey'
						element={
							<LazyLoader>
								<SurveyForm />
							</LazyLoader>
						}
					/> */}
					<Route
						path='recurringsurvey'
						element={
							<LazyLoader>
								<SurveyForm />
							</LazyLoader>
						}
					/>
					<Route element={<ProtectRoutes />}>
						<Route
							path=''
							element={
								<LazyLoader>
									<Mainlayout />
								</LazyLoader>
							}>
							{user?.role === "external" ? (
								<Route
									path='/dashboard'
									element={
										<LazyLoader>
											<LocalDashboard />
										</LazyLoader>
									}
								/>
							) : (
								accesspoint?.includes("dashboard") ||
								(adminRole.includes(user?.role) && (
									<Route
										path='/dashboard'
										element={
											<LazyLoader>
												<Dashboard />
											</LazyLoader>
										}
									/>
								))
							)}
							{accessroutingPage()}

							<Route
								path='smtp'
								element={
									<LazyLoader>
										<SMTPSetting />
									</LazyLoader>
								}
							/>
							<Route
								path=':name/formbuilder'
								element={
									<LazyLoader>
										<FormsBuilder />
									</LazyLoader>
								}
							/>
							{/* <Route
						path=':name'
						element={
							<LazyLoader>
								<TemplatePage />
							</LazyLoader>
						}
					/> */}
							<Route
								path='usersetting'
								element={
									<LazyLoader>
										<UserSetting />
									</LazyLoader>
								}
							/>
							<Route
								path='*'
								element={
									<LazyLoader>
										<div className='d-flex h-100 justify-content-center align-items-center'>
											{user.role === "admin" ? (
												<p className='text-primary text-center h1'>
													404 <br /> Page Not Found{" "}
												</p>
											) : (
												<p className='text-primary h1'>Access Denied</p>
											)}
										</div>
									</LazyLoader>
								}
							/>
							<Route
								path='analysis/:id'
								element={
									<LazyLoader>
										<SurveyAnalysisPage variant='service' />
									</LazyLoader>
								}
							/>
							<Route
								path='recurringanalysis/:id'
								element={
									<LazyLoader>
										<SurveyAnalysisPage variant='recurring' />
									</LazyLoader>
								}
							/>
							<Route
								path='employeeevaluation/:id'
								element={
									<LazyLoader>
										<SurveyAnalysisPage variant='employee' />
									</LazyLoader>
								}
							/>
							<Route
								path='vendorevaluation/:id'
								element={
									<LazyLoader>
										<SurveyAnalysisPage variant='vendor' />
									</LazyLoader>
								}
							/>
							<Route
								path='equipmentevaluation/:id'
								element={
									<LazyLoader>
										<SurveyAnalysisPage variant='equipment' />
									</LazyLoader>
								}
							/>
							<Route
								path='clientevaluation/:id'
								element={
									<LazyLoader>
										<SurveyAnalysisPage variant='client' />
									</LazyLoader>
								}
							/>
						</Route>
					</Route>
				</Routes>
			)}

			<ToastContainer
				theme='light'
				autoClose={3000}
				closeButton={true}
				closeOnClick={false}
				draggable={false}
			/>
		</>
	);
}

export default App;
